import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useCallback } from 'react'
import {
  getProperty,
  createProperty,
  patchProperty,
  approveProperty,
  declineProperty,
  deleteProperty,
} from '../services/propertyApi.js'

// Validation helper function
const isValidId = propertyId => {
  return /^[a-f\d]{24}$/i.test(propertyId) // Example for MongoDB ID validation
}

const useProperty = propertyId => {
  const dispatch = useDispatch()
  const { currentProperty, loading, error } = useSelector(state => state.property)

  // Fetch property data
  const fetchPropertyData = useCallback(() => {
    if (propertyId && isValidId(propertyId)) {
      dispatch(getProperty(propertyId))
    }
  }, [dispatch, propertyId])

  useEffect(() => {
    fetchPropertyData()
  }, [fetchPropertyData])

  return {
    property: currentProperty,
    loading,
    error,
    getProperty: propertyId => dispatch(getProperty(propertyId)),
    createProperty: data => dispatch(createProperty(data)),
    patchProperty: (propertyId, updatedData) => dispatch(patchProperty(propertyId, updatedData)),
    approveProperty: (propertyId, context) => dispatch(approveProperty(propertyId, context)),
    declineProperty: (propertyId, statusData) => dispatch(declineProperty(propertyId, statusData)),
    deleteProperty: propertyId => dispatch(deleteProperty(propertyId)),
  }
}

export default useProperty
